import { render, staticRenderFns } from "./CourseGoods.vue?vue&type=template&id=3ed1963c&scoped=true&"
import script from "./CourseGoods.vue?vue&type=script&lang=js&"
export * from "./CourseGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1963c",
  null
  
)

export default component.exports